var _desc, _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M3.06 0.75L0.9 4.5C0.7 4.83 0.95 5.25 1.33 5.25L5.66 5.25C6.04 5.25 6.29 4.83 6.09 4.5L3.93 0.75C3.74 0.41 3.25 0.41 3.06 0.75Z",
    fill: "#1F0A35",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2",
    d: "M3.06 11.25L0.9 7.5C0.7 7.16 0.95 6.75 1.33 6.75L5.66 6.75C6.04 6.75 6.29 7.16 6.09 7.5L3.93 11.25C3.74 11.58 3.25 11.58 3.06 11.25Z",
    fill: "#1F0A35",
    fillOpacity: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortArrow);
export default __webpack_public_path__ + "static/media/sortArrow.b8e8c5ece3fbbdb4184948ce1739daaf.svg";
export { ForwardRef as ReactComponent };